export { default as Accordion } from './Accordion'
export { default as Button } from './Button'
export { default as ButtonFixed } from './ButtonFixed'
export { default as Container } from './Container'
export { default as Field } from './Field'
export { default as Header } from './Header'
export { default as Icon } from './Icon'
export { default as If } from './If'
export { default as Loader } from './Loader'
export { default as LoaderPage } from './LoaderPage'
export { default as Slider } from './Slider'
export { default as Title } from './Title'
export { default as Carousel } from './Carousel'
export { default as Footer } from './Footer'
export { default as FooterHome } from './Footer/FooterHome'
export { default as CardPlan } from './CardPlan'
export { default as TipsBar } from './Tipsbar'
export { default as Video } from './Video'
export { default as CardDetail } from './CardPlanDetail'
export { default as Modal } from './Modal'
export { default as TopbarFixed } from './TopbarFixed'
export { default as CardSinglePlan } from './CardSinglePlan'
export { default as FormSoftlead } from './FormSoftlead'
